import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "./../Global/NanoFlex.js";
import Type from "../Global/Typography.js";
import Dropdown from "./../Nano/Dropdown.js";

const multiple = nota.global.multiple;

const StyledTitleCard = styled.div`
  margin-left: ${multiple / 2 + "px"}; /* 4px */
  position: relative;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: calc(100% - 100px);
  .titleWrapper {
    margin-bottom: ${multiple + "px"}; /* 8px */
    height: auto;
    flex-wrap: wrap;
    .primaryTitleWrapper {
      cursor: pointer;
      margin-right: ${multiple * 2 + "px"}; /* 16px */
      /* width: auto; */
      display: -webkit-box;
      display: -webkit-flex;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    h3 {
      line-height: 18px;
    }
    h5 {
      /* margin-left: -${multiple / 2 + "px"}; */
      text-transform: uppercase;
      color: ${nota.color.main.default};
    }
    .darkTitle {
      margin-left: 0px;
      color: ${nota.color.neutral.NeuOne};
    }
    .secondaryTitleWrapper {
      width: auto;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      h4 {
        color: ${nota.color.neutral.NeuOne};
      }
    }
    .iconWrapper {
      position: absolute;
      right: 0;
      top: 0;
      cursor: ${(props) => (props.iconHoverContent ? `pointer` : `default`)};
      img {
        width: ${multiple * 2 + "px"}; /* 8px */
      }
    }
  }
  @media only screen and (max-width: ${nota.global.breakpoints.smallTablet + "px"}) {
    h3 {
      font-size: 14px;
    }
    p {
      width: 70%;
      font-size: 10px;
    }
    h5 {
      width: 70%;
      font-size: 12px;
    }
  }
  @media only screen and (max-width: 800px) {
    width: 100%;
    .titleWrapper {
      .primaryTitleWrapper {
        display: -webkit-box;
        display: -webkit-flex;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .secondaryTitleWrapper {
        display: -webkit-box;
        display: -webkit-flex;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
`;

const TitleCard = (props) => {
  return (
    <StyledTitleCard className="titleContainer" iconHoverContent={props.iconHoverContent}>
      <NanoFlex className="titleWrapper" justifyContent={"flex-start"} alignContent={"flex-start"}>
        <NanoFlex className="primaryTitleWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} onClick={props.handleOnClick}>
          <Type.h3 className={props.titleClass}>
            <b>{props.title}</b>
          </Type.h3>
          {props.simpleTitle && (
            <Type.h5>
              <b>{props.simpleTitle}</b>
            </Type.h5>
          )}
          {props.darkTitle && (
            <Type.h5 className="darkTitle">
              <b>{props.darkTitle}</b>
            </Type.h5>
          )}
        </NanoFlex>

        <NanoFlex className="secondaryTitleWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
          <Type.p>
            <em>{props.subTitle}</em>
          </Type.p>
          <Type.h4>{props.secTitle}</Type.h4>
        </NanoFlex>
        <div className="iconWrapper">
          <Dropdown onClickOutsideClose main={<img src={props.icon} />} content={props.iconHoverContent || <div></div>} />
        </div>
      </NanoFlex>
    </StyledTitleCard>
  );
};

// Set default props
TitleCard.defaultProps = {
  title: "", // 'List Title'
  titleClass: "",
  simpleTitle: "", // 'Simple Title'
  darkTitle: "", // 'Dark Title'
  subTitle: "", // 'Sub Title'
  secTitle: "", // 'Secondary Title'
  icon: "", // Image Src
  iconHoverContent: false,
};

export default TitleCard;

// --- // Documentation // --- //
/*
import TitleCard from './../Nano/TitleCard.js';

<TitleCard
    title={'List Title'}
    simpleTitle={'Simple Title'}
    darkTitle={'Dark Title'}
    subTitle={'Sub Title'}
    secTitle={'Secondary Title'}
    icon={img src}
/>
*/
